import type { ObservationPhaseVocabulary } from "@bitacorapro/api-types";
import { Skel } from "../components/Skel";
import { SkelTable } from "../components/skeleton/SkelTable";
import { ESTADO_COLUMNS, columnTitle } from "../lib/postventa/entryThread";

// Observaciones' loading compositions (ADR-0166). Every block sits in
// the real container of what replaces it — the same .panel, .filters,
// .dtable and .kanban boxes — so the list lands without a shift. Counts
// are what fills a 1280×800 viewport under the page header and the bar.

const TABLE_ROWS = 8;
const KANBAN_CARDS = 3;

// The real table's static column headers (Observaciones.tsx ObsTable).
const TABLE_HEADERS = [
  "Observación",
  "Tienda",
  "Severidad",
  "Evidencia",
  "Estado",
  "Asignada a",
  "",
];

/** The filter bar: search box, the four dropdown chips, Exportar CSV
 *  and the result count, each in its real box (30px chips/search). */
function FiltersSkeleton() {
  return (
    <div className="filters" aria-hidden="true">
      <div className="filter-search">
        <Skel variant="text" width="60%" />
      </div>
      {[88, 96, 80, 100].map((w, i) => (
        <Skel key={i} width={w} height={30} />
      ))}
      <div className="filter-spacer" />
      <Skel width={112} height={30} />
      <span className="filter-sort">
        <Skel variant="text" width={72} />
      </span>
    </div>
  );
}

/** The kanban board: one real column per thread phase (titles are the
 *  recipe's labels, static once the recipe is known), cards as blocks. */
function KanbanSkeleton({ vocab }: { vocab: ObservationPhaseVocabulary | undefined }) {
  return (
    <div className="kanban" aria-hidden="true">
      {ESTADO_COLUMNS.map((col) => (
        <div key={col.key} className="kanban__col">
          <div className="kanban__head">
            <span className="kanban__head-title">
              {vocab ? columnTitle(col.key, vocab) : <Skel variant="text" width={80} />}
            </span>
          </div>
          <div className="kanban__body">
            {Array.from({ length: KANBAN_CARDS }, (_, i) => (
              <Skel key={i} variant="card" width="100%" height={112} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/** The list body while the dashboard (or the recipe it waits on) loads:
 *  the panel with its filter bar and the table — or the board, when the
 *  user already switched to Kanban. */
export function ObservacionesBodySkeleton({
  view = "table",
  vocab,
}: {
  view?: "table" | "kanban";
  vocab?: ObservationPhaseVocabulary | undefined;
}) {
  return (
    <div className="panel">
      <FiltersSkeleton />
      {view === "table" ? (
        <SkelTable rows={TABLE_ROWS} cols={TABLE_HEADERS.length} headers={TABLE_HEADERS} />
      ) : (
        <KanbanSkeleton vocab={vocab} />
      )}
    </div>
  );
}
